import { type CSSProperties, type FC } from "react";

const DECOY_FIELD_STYLE: CSSProperties = {
  position: "absolute",
  left: "-9999px",
  width: 0,
  height: 0,
  overflow: "hidden",
  opacity: 0,
  pointerEvents: "none"
};

export const BrowserAutocompleteDecoyFields: FC = () => (
  <div aria-hidden="true" data-testid="browser-autocomplete-decoys" style={DECOY_FIELD_STYLE}>
    <input type="text" name="street-address" autoComplete="address-line1" tabIndex={-1} readOnly />
    <input type="text" name="address-line2" autoComplete="address-line2" tabIndex={-1} readOnly />
    <input type="text" name="city" autoComplete="address-level2" tabIndex={-1} readOnly />
    <input type="text" name="state" autoComplete="address-level1" tabIndex={-1} readOnly />
    <input type="text" name="zip" autoComplete="postal-code" tabIndex={-1} readOnly />
    <input type="text" name="given-name" autoComplete="given-name" tabIndex={-1} readOnly />
    <input type="text" name="family-name" autoComplete="family-name" tabIndex={-1} readOnly />
    <input type="email" name="email" autoComplete="email" tabIndex={-1} readOnly />
    <input type="tel" name="tel" autoComplete="tel" tabIndex={-1} readOnly />
  </div>
);
